import "@fortawesome/fontawesome-free/css/all.css"; // Ensure you are using css-loader
import Vue from "vue";
import Vuetify from "vuetify";

Vue.use(Vuetify, {
  iconfont: "fa"
});
